import StyledSelect from './components/styled-select';
import ScrollDepthTracking from 'marketing/utils/ScrollDepthTracking';
import ScrollToElement from './components/ScrollToElement';
import { trackLink } from '@99designs/common/utils/platform';

// -----------------------------------------------------------------------------
// Hero select styles
// -----------------------------------------------------------------------------

document.addEventListener('DOMContentLoaded', () => {
    let element = document.querySelector('[data-styled-select]');
    new StyledSelect(element);
});

// -----------------------------------------------------------------------------
// Redirect on pricing selection
// -----------------------------------------------------------------------------

document.addEventListener('DOMContentLoaded', () => {
    const select = document.querySelector('[data-styled-select-select]');
    const selectedIndex = select.selectedIndex;

    function handleSelectChange(event) {
        const pricingPath = `/pricing/${select.value}`;

        // Make sure select fires only once on change to enable to persist state
        select.removeEventListener('change', handleSelectChange);

        // Keep existing category selected to work around browser caching the
        // select state while using browser history
        select.options[selectedIndex].selected = true;

        // Re-add the eventlistener so that Safari can still work from cache
        select.addEventListener('change', handleSelectChange);

        // Redirect to new URL
        window.location.pathname = pricingPath;
    }

    select.addEventListener('change', handleSelectChange);
});

document.addEventListener('DOMContentLoaded', () => {
    const elements = document.querySelectorAll('[data-scrollto]');

    for (const element of elements) {
        new ScrollToElement(element).handleClick();
    }
});

// -----------------------------------------------------------------------------
// Tracking
// -----------------------------------------------------------------------------

// Track scroll position
document.addEventListener('DOMContentLoaded', () => {
    new ScrollDepthTracking('Pricing');
});

// CTA click tracking
document.addEventListener('DOMContentLoaded', () => {
    const pricingCTA = document.querySelectorAll('[data-pricing-cta]');

    Array.from(pricingCTA).forEach(element => {
        trackLink(element, 'Clicked CTA on Pricing page', {
            cta_location: element.getAttribute('data-pricing-cta-location'),
        });
    });
});
